import Box from "ds/components/Box";
import SpacePath from "components/SpacePath";

import { ApiKeyViewRoleBinding } from "../../types";

type ApiKeyRolesListItemGrantedAtCellProps = {
  roleBinding: ApiKeyViewRoleBinding;
};

const ApiKeyRolesListItemGrantedAtCell = ({
  roleBinding,
}: ApiKeyRolesListItemGrantedAtCellProps) => {
  return (
    <Box align="center" fullWidth>
      <SpacePath spaceId={roleBinding.space.id} fallbackName={roleBinding.space.name} />
    </Box>
  );
};

export default ApiKeyRolesListItemGrantedAtCell;
